class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
//   }
// }

// Added code for open submenu on Hover for Desktop
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Only apply hover behavior on desktop
    if (window.innerWidth >= 1025) {
      this.addHoverEvents();
      this.addSubmenuHoverEvents();
    }
  }

  addHoverEvents() {
    const details = this.mainDetailsToggle;

    // Open on hover
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', true);
      details.querySelector('summary').setAttribute('aria-expanded', true);
    });

    // Close when mouse leaves
    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', false);
    });
  }

  addSubmenuHoverEvents() {
    const submenuDetails = this.mainDetailsToggle.querySelectorAll('details');
    submenuDetails.forEach((details) => {
      if (details === this.mainDetailsToggle) return;
      const summary = details.querySelector('summary');
      const submenuChildren = details.querySelector('ul');
      if (!summary) return;

      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });
      
      submenuChildren.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

